import Vue from "vue";
import App from "./App.vue";
import  "./assets/css/public.scss";
// import 'lib-flexible/flexible.js'
import '@/utils/flex'

import router from "./router";
import store from "./store";
import  i18n  from "@/../public/i18n";
import ElementUI from "element-ui"; // 引入 Element UI
import "element-ui/lib/theme-chalk/index.css"; // 引入 Element UI 的样式
Vue.config.productionTip = false;
Vue.use(ElementUI); // 使用 Element UI
new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

window.addEventListener('contextmenu', function (e) {  
  e.preventDefault();  
}); 